import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/filter/calendar-alt.png'
import _imports_1 from '../../../../assets/filter/calendar-alt.svg'


const _withScopeId = n => (_pushScopeId("data-v-31ff3876"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = {
  class: "d-flex flex-column w-100 mb-3",
  id: "testeSelect"
}
const _hoisted_3 = { class: "d-flex flex-row fs-4" }
const _hoisted_4 = {
  key: 0,
  class: "ms-4 text-danger fs-6"
}
const _hoisted_5 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_6 = { class: "d-flex flex-column w-100 mb-3" }
const _hoisted_7 = { class: "fs-4" }
const _hoisted_8 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_9 = { class: "d-flex flex-column w-100 mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-4" }, "Versão", -1))
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  class: "col-6",
  id: "yearInit"
}
const _hoisted_13 = { class: "mt-1 fs-4" }
const _hoisted_14 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_15 = {
  class: "d-flex flex-row p-1 bg-white rounded-2",
  style: {"border":"0.5px solid gray"},
  id: "anoInput"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "p-2"
}, null, -1))
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Ano inicial", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  class: "col-6",
  id: "yearFinal"
}
const _hoisted_21 = { class: "mt-1 ms-1 fs-4" }
const _hoisted_22 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_23 = {
  class: "d-flex flex-row p-1 bg-white rounded-2",
  style: {"border":"0.5px solid gray"},
  id: "anoInput"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "p-2"
}, null, -1))
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Ano final", -1))
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "d-flex flex-column" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-4 mt-3" }, "Fipe", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_FilterBase = _resolveComponent("FilterBase")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "veiculosIndicacao",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: true,
    onSearch: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterYearModel(), _ctx.verifySelectValues(), _ctx.setCurrentPage(1), _ctx.numberPages()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode("Marca "),
            (_ctx.spanWarning == true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Preencha todos os campos obrigatorios "))
              : _createCommentVNode("", true),
            (_ctx.spanWarning == true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " * "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_select, {
            modelValue: _ctx.marcaSelecionada,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.marcaSelecionada) = $event)),
            filterable: "",
            placeholder: "Selecione uma marca",
            clearable: "",
            style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
            "arrow-class": "custom-arrow",
            onChange: _ctx.getModelosPorMarcas
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marcasDeVeiculos, (montadora, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: montadora.marca,
                  value: montadora.marca
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createTextVNode("Modelo "),
            (_ctx.spanWarning == true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " * "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_select, {
            modelValue: _ctx.veiculoSelecionado,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.veiculoSelecionado) = $event)),
            filterable: "",
            placeholder: "Selecione um modelo",
            disabled: false,
            clearable: "",
            style: {"border-radius":"5px","border":"1px solid #b5b5c3"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allModelosFiltered, (veiculo, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: veiculo,
                  value: veiculo
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_el_input, {
            modelValue: _ctx.inputTypeMotor,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputTypeMotor) = $event)),
            filterable: "",
            placeholder: "Versão de motor/valvulas",
            clearable: "",
            style: {"border-radius":"5px","border":"1px solid #b5b5c3"}
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, [
              _createTextVNode("De:"),
              (_ctx.spanWarning == true)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, " * "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.clientYearInit) = $event)),
                style: {"font-size":"1.1rem","background":"none","border":"none"},
                class: "text-center w-100 p-0",
                disabled: !_ctx.veiculoSelecionado
              }, [
                _hoisted_18,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearInit, (year, key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: year,
                    key: key
                  }, _toDisplayString(year), 9, _hoisted_19))
                }), 128))
              ], 8, _hoisted_17), [
                [_vModelSelect, _ctx.clientYearInit]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, [
              _createTextVNode("Até: "),
              (_ctx.spanWarning == true)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, " * "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.clientYearFinal) = $event)),
                style: {"font-size":"1.1rem","background":"none","border":"none"},
                class: "text-center w-100 p-0",
                disabled: !_ctx.clientYearInit
              }, [
                _hoisted_26,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearFinal, (year, key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: year,
                    key: key
                  }, _toDisplayString(year), 9, _hoisted_27))
                }), 128))
              ], 8, _hoisted_25), [
                [_vModelSelect, _ctx.clientYearFinal]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createVNode(_component_el_input, {
            modelValue: _ctx.fipeNumero,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fipeNumero) = $event)),
            placeholder: "Digite a FIPE do veículo",
            clearable: ""
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal"]))
}